import * as React from 'react';

function SvgAccountCenter(props) {
  return (
    <svg width={16} height={13} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12.42 6.99c1.178 0 2.138-.94 2.138-2.095 0-1.155-.96-2.095-2.138-2.095-1.179 0-2.138.94-2.138 2.095 0 1.155.96 2.095 2.138 2.095zm-7.06-.422c1.848 0 3.352-1.473 3.352-3.284C8.712 1.474 7.208 0 5.36 0 3.513 0 2.01 1.473 2.01 3.284c0 1.81 1.503 3.284 3.35 3.284zm5.33 1.142c.144.185 1.282 1.223 1.282 3.245h1.329c1.448 0 2.699 0 2.699-.763v-.156c0-1.458-1.112-2.462-2.6-2.462h-1.8c-.323 0-.63.047-.91.136zm-3.793-.54c2.263 0 3.97 1.48 4.07 3.653l.006.205v.246c0 1.115-1.708 1.19-3.782 1.195l-3.876-.003C1.476 12.448.11 12.32.006 11.39L0 11.274v-.246c0-2.216 1.638-3.762 3.865-3.854l.21-.004h2.822z" />
    </svg>
  );
}

export default SvgAccountCenter;
